import { TaskStatus as TaskStatusEnum } from "@common/types/task";
import { HStack } from "@design-system/HStack/HStack";
import { TASK_STATUS_CONFIG } from "./taskStatus.constants";
import { TaskStatusIcon } from "./TaskStatusIcon";

interface TaskStatusProps {
    status: TaskStatusEnum;
    showIcon?: boolean;
    showText?: boolean;
}

export const TaskStatus = ({ status, showIcon, showText }: TaskStatusProps) => (
    <HStack gap={8} align="center">
        {showIcon ? (
            <TaskStatusIcon status={status} withTooltip={false} />
        ) : null}
        {showText ? <span>{TASK_STATUS_CONFIG[status].tooltip}</span> : null}
    </HStack>
);
